import { useSocketAccountingEventInvalidator } from 'hooks/useSocketAccountingEventInvalidator';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { getAccountingEntryByLedgerCode } from 'utils/accounting';
import {
  LEDGER_CODE_LOAN_AMOUNT,
  LEDGER_CODE_LOAN_NETFUNDED,
  CHARGES_LENDER_CREDITS,
  LEDGER_CODE_PAIDBY_OTHERS,
  LEDGER_CODE_LENDER_CHARGES,
  LEDGER_CODE_LOAN_FUNDING,
  LEDGER_CODE_AGGREGATE_ADJUSTMENTS
} from 'utils/constants';
import { getOrder } from '../../services/querys';

export const useBalancing = () => {
  const { t } = useTranslation();
  const { id: orderId } = useParams<{ id: string}>();

  useSocketAccountingEventInvalidator({ queries: ['disbursements-balancing', orderId] });

  const { data: accountingResponse } = useQuery(
    ['disbursements-balancing', orderId],
    () => getOrder(orderId),
    {
      enabled: !!orderId,
      refetchOnWindowFocus: false,
    }
  );

  const accountingBalance = accountingResponse?.getOrder.accounting || [];

  const getEntryByLedgerCode = (ledgerCode: string) => getAccountingEntryByLedgerCode({ accounting: accountingBalance, ledgerCode });
  const loanAmount = getEntryByLedgerCode(LEDGER_CODE_LOAN_AMOUNT)?.amount || 0;
  const netFunded = getEntryByLedgerCode(LEDGER_CODE_LOAN_NETFUNDED)?.amount || 0;
  const lenderCredits = getEntryByLedgerCode(CHARGES_LENDER_CREDITS)?.amount || 0;
  const paidByOthers = getEntryByLedgerCode(LEDGER_CODE_PAIDBY_OTHERS)?.amount || 0;
  const lenderCharges = getEntryByLedgerCode(LEDGER_CODE_LENDER_CHARGES)?.amount || 0;
  const loanFunding = getEntryByLedgerCode(LEDGER_CODE_LOAN_FUNDING)?.amount || 0;
  const aggregateAdjustment = getEntryByLedgerCode(LEDGER_CODE_AGGREGATE_ADJUSTMENTS)?.amount || 0;

  return {
    t,
    loanAmount,
    netFunded,
    lenderCredits,
    paidByOthers,
    lenderCharges,
    loanFunding,
    aggregateAdjustment
  };
};
